import {lazyRegister} from '@/Core/lazyRegister';
import './select-floating.component.css';
import template from './select-floating.component.html';
import {createRandomId} from "@core/global";
import {OptionModel} from "@components/Forms";

class SelectFloatingController {
    static $inject = [];
    public options: OptionModel[] = [];
    public placeholder: string;
    public required: boolean = false;
    public showOptionWhen: boolean = true;
    public model: any;
    public id?: string;
    public disabled: boolean = false;
    public icon?: string;
    public error?: string;
    public containerClass?: string;
    public selectClass?: string;
    public hasIconAction?: boolean;
    public onChange: (params: { $value: any }) => void;
    public onIconClick: () => void;
    showEmptyOption: boolean;
    ngModel: ng.INgModelController;

    constructor() {
    }

    $onInit(): void {
        this.ngModel.$render = () => {
            this.model = this.ngModel.$viewValue;
        };

        if (!this.id) {
            this.id = 'select-' + createRandomId();
        }

        this.options = this.options || [];
        this.hasIconAction = typeof this.onIconClick == "function";

        if (this.showEmptyOption === undefined)
            this.showEmptyOption = !this.options.some(option => option.value === null || option.value === '' || option.value === undefined);
    }

    handleValueChange() {
        this.ngModel.$setViewValue(this.model);

        if (this.onChange) {
            this.onChange({$value: this.model});
        }
    }

    handleIconClick() {
        if (this.onIconClick) {
            this.onIconClick();
        }
    }
}

export const SelectFloatingComponent: ng.IComponentOptions = {
    require: {
        ngModel: 'ngModel'
    },
    bindings: {
        options: '<',
        placeholder: '@?',
        id: '@?',
        showEmptyOption: '<?',
        disabled: '<?',
        required: '<?',
        showOptionWhen: '<?',
        onChange: '&?',
        onIconClick: '&?',
        icon: '@?',
        error: '<?',
        containerClass: '@?',
        selectClass: '@?'
    },
    template: template,
    controller: SelectFloatingController
};

lazyRegister.component('selectFloating', SelectFloatingComponent);
